import { type AxiosInstance } from "axios";
import type { ParseResult } from "@/features/dmManagement/types";
import { handleMutationError } from "@/features/dmManagement/api/handleApiError";

/**
 * 宛先リストファイルをアップロードしてパース結果を取得する。
 * @param apiClient - axios インスタンス
 * @param file - アップロードする宛先リストファイル
 * @returns パース結果（宛先データ・エラー情報）
 */
export const PostAddressListParseAPI = async (
  apiClient: AxiosInstance,
  file: File,
  signal?: AbortSignal
): Promise<ParseResult> => {
  const url = "/dm/address-list/parse/";

  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await apiClient.post<ParseResult>(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      signal,
    });
    return response.data;
  } catch (error) {
    return handleMutationError(error);
  }
};
